import { useMemo } from 'react';

import type IFreeButtonDialogAction from '@sravni/vitrina/lib/types/config/IFreeButtonDialogAction';
import type IFreeButtonLinkAction from '@sravni/vitrina/lib/types/config/IFreeButtonLinkAction';

import { useProductConfig } from '../../../../../store/hooks/productPopupInfo';

export const useFreeButtonAction = (): IFreeButtonDialogAction | IFreeButtonLinkAction => {
  const config = useProductConfig();

  return useMemo(() => {
    if (!config.freeButtonAction) {
      return {};
    }

    return {
      ...config.freeButtonAction,
    };
  }, [config]);
};
